import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-guest-layout',
  templateUrl: './guest-layout.component.html'
})
export class GuestLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
